import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGrowth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGrowth"><Path d="M3 3V5C3 9.28021 6.46979 12.75 10.75 12.75H11.25V21H12.75V16H13.25C17.5302 16 21 12.5302 21 8.25V6H19C16.3562 6 14.0216 7.32382 12.6229 9.34475C11.9618 5.73541 8.80036 3 5 3H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGrowth;
